import http from '../jslibs/axios/http';

export const getFileList = data => http.get('/cms/FileCom', data);
export const addFileList = data => http.post('/cms/FileCom', data);
export const editFileList = data => http.put(`/cms/FileCom/${data.uuid}`, data);
export const deleteFileList = uuid => http.delete(`/cms/FileCom/${uuid}`);
export const getFileDetail = uuid => http.get(`/cms/FileCom/${uuid}`);